/**
 * TODO: See if this can be removed if it is no longer needed by latest TypeScript version.
 * See: https://devblogs.microsoft.com/typescript/announcing-typescript-5-5/#inferred-type-predicates
 *
 * Useful with `.filter()`, this allows filtering an array with `.map()` and producing type-safe results.
 * A better way to do `.filter(Boolean)`.
 * Adapted from https://stackoverflow.com/a/58110124
 */
export function truthyFilter(value) {
    return !!value;
}
export function assertUnreachable(x) {
    throw new Error(`This should be unreachable! but got ${x}`);
}
